import type { MarketingPageContent } from './types';

export const FOR_AGENCIES_CONTENT: MarketingPageContent = {
  title: 'Induce for Agencies & Enterprises',
  headerLabel: 'For Agencies',
  lede:
    'Induce is the AI media infrastructure for the next generation of content creation. For agencies and production teams shipping branded work on a clock.',
  sections: [
    {
      id: 'studio-workflow',
      title: 'Built for production teams',
      body: 'For agencies and production teams shipping branded work on a clock. Brand continuity memory, style locks, team workspaces, SSO, and audit log.',
    },
    {
      id: 'enterprise',
      title: 'Enterprise infrastructure',
      body: 'Custom render capacity, private continuity models, API integrations, and dedicated support. Usage and retry terms are defined in your Enterprise agreement.',
    },
    {
      id: 'api',
      title: 'API and integrations',
      body: 'Yes. A REST API and SDKs for Node and Python let you drop Induce into an existing pipeline. Webhooks for render completion, status, and continuity events.',
    },
  ],
};
